import auth0 from "../auth0-client";

export default {
  install(Vue) {
    Vue.prototype.$auth0 = auth0;
  }
}
